import React from 'react';
import { Bell, ChevronRight, MapPin, QrCode, Search, ShieldCheck } from 'lucide-react';
import { DmpLogo } from '../../brand/DmpLogo';
import { MobileBottomNav } from '../MobileBottomNav';
import { StatusBadge } from '../../common/StatusBadge';
import { mobileHistory } from '../../../data/verifications';
import { resultTone } from '../../../utils/status';
import type { MobileNav } from '../../../types/mobile';
const stats = [{
  label: 'আজ যাচাই',
  value: '২৪',
  cls: 'text-navy-800 bg-navy-50'
}, {
  label: 'বৈধ',
  value: '২০',
  cls: 'text-emerald-700 bg-emerald-50'
}, {
  label: 'সমস্যা পাওয়া গেছে',
  value: '৩',
  cls: 'text-amber-700 bg-amber-50'
}, {
  label: 'অবৈধ',
  value: '১',
  cls: 'text-red-700 bg-red-50'
}];
export function HomeScreen({
  nav
}: {
  nav: MobileNav;
}) {
  return <div className="flex h-full flex-col bg-slate-50" data-id="element-899" data-mp="2e4wqqspvxbxk">
      <header className="bg-navy-800 px-4 pb-16 pt-2 text-white" data-id="element-900" data-mp="2e3bwz5be9x0r">
        <div className="flex items-center gap-2.5" data-id="element-901" data-mp="2a4ureq7mgulg">
          <DmpLogo size={34} data-id="element-902" data-mp="1m4rojk6fsmo6" />
          <div className="flex-1" data-id="element-903" data-mp="1m5jm30jlguh3">
            <h1 className="font-heading text-base font-semibold" data-id="element-904" data-mp="1m6kvz1ovjax8">ডিএমপি ভেরিফিকেশন</h1>
            <p className="flex items-center gap-1 text-[11px] text-navy-200" data-id="element-905" data-mp="1q74w8e4quunl"><MapPin className="h-3 w-3" data-id="element-906" data-mp="1v4wudpvzfd08" />মিরপুর-১০ গোলচত্বর • ডিউটিরত</p>
          </div>
          <button aria-label="নোটিফিকেশন" className="relative flex h-9 w-9 items-center justify-center rounded-full hover:bg-white/10" data-id="element-907" data-mp="2049j6g6eyu5g">
            <Bell className="h-5 w-5" data-id="element-908" data-mp="252ui8c9xj7sb" />
            <span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-flagred" data-id="element-909" data-mp="251t604h6gf90" />
          </button>
        </div>
      </header>

      <div className="no-scrollbar -mt-12 flex-1 overflow-y-auto px-4 pb-4" data-id="element-910" data-mp="2dvfq2xc0vu2d">
        <div className="rounded-xl border border-border bg-white p-3.5 shadow-sm" data-id="element-911" data-mp="2iv0wttxfp6pn">
          <div className="flex items-center gap-3" data-id="element-912" data-mp="2iwv9kkyjxsin">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy-50 text-navy-800" data-id="element-913" data-mp="2nv6hur977uyr"><ShieldCheck className="h-6 w-6" data-id="element-914" data-mp="2su9o2f0x078b" /></span>
            <div className="min-w-0 flex-1 text-xs" data-id="element-915" data-mp="2squbpjymlcal">
              <p className="text-sm font-semibold text-navy-900" data-id="element-916" data-mp="235uk3yddqrqy">নাম: সার্জেন্ট মোঃ কামরুল হাসান</p>
              <p className="text-slate-500" data-id="element-917" data-mp="1y7at3jjxiprq">বিপি নং: <span className="font-mono" data-id="element-918" data-mp="1y456qc2oq1zp">BP-2587</span></p>
              <p className="text-slate-500" data-id="element-919" data-mp="2cvnskqi86qqz">ইউনিট: ট্রাফিক-মিরপুর</p>
            </div>
            <StatusBadge tone="green" data-id="element-920" data-mp="2834frvrd3zn8">অনলাইন</StatusBadge>
          </div>
        </div>

        <button onClick={() => nav.go('scanner')} className="mt-4 flex w-full items-center gap-4 rounded-xl bg-bdgreen-600 p-5 text-left text-white shadow-sm transition active:scale-[0.99]" data-id="element-921" data-mp="2lurdm00ydg84">
          <span className="flex h-14 w-14 items-center justify-center rounded-lg bg-white/15" data-id="element-922" data-mp="2vsf9wue7ivse"><QrCode className="h-8 w-8" data-id="element-923" data-mp="2qudrmbolv0hz" /></span>
          <span className="flex-1" data-id="element-924" data-mp="2qskgok6ylu46">
            <span className="block font-heading text-xl font-bold" data-id="element-925" data-mp="11f78ukzn1nyb">QR স্ক্যান করুন</span>
            <span className="text-xs text-bdgreen-100" data-id="element-926" data-mp="wgvz0a9cfdg3">সিএনজি স্টিকার স্ক্যান করে তাৎক্ষণিক যাচাই</span>
          </span>
          <ChevronRight className="h-5 w-5" data-id="element-927" data-mp="383pppsx79qzk" />
        </button>
        <button onClick={() => nav.go('search')} className="mt-2.5 flex w-full items-center gap-3 rounded-xl border border-border bg-white px-4 py-3.5 text-left text-navy-800" data-id="element-928" data-mp="386c000bh6klh">
          <Search className="h-5 w-5" data-id="element-929" data-mp="33d9ca8tdq5d7" />
          <span className="flex-1 text-sm font-semibold" data-id="element-930" data-mp="33c7qpaeqm0h8">গাড়ির নম্বর দিয়ে খুঁজুন</span>
          <ChevronRight className="h-4 w-4 text-slate-400" data-id="element-931" data-mp="2pd8betd46xxq" />
        </button>

        <h2 className="mb-2 mt-5 text-xs font-semibold text-slate-500" data-id="element-932" data-mp="2tetn4bdwx66c">আজকের পরিসংখ্যান</h2>
        <div className="grid grid-cols-2 gap-2" data-id="element-933" data-mp="2ffagjn0r22w5">
          {stats.map(s => <button key={s.label} onClick={() => nav.go('history')} className="rounded-lg border border-border bg-white p-3 text-left" data-id="element-934" data-mp="2fhn5ik4xddip">
              <p className="text-[11px] text-slate-500" data-id="element-935" data-mp="dnfelz4apcr4">{s.label}</p>
              <p className={`mt-1 inline-block rounded px-1.5 font-heading text-xl font-bold ${s.cls}`} data-id="element-936" data-mp="dm4b80eri70j">{s.value}</p>
            </button>)}
        </div>

        <div className="mb-2 mt-5 flex items-center justify-between" data-id="element-937" data-mp="2epn2wbx8esy1">
          <h2 className="text-xs font-semibold text-slate-500" data-id="element-938" data-mp="29qu13grb4qdp">সাম্প্রতিক যাচাই</h2>
          <button onClick={() => nav.go('history')} className="text-xs font-medium text-navy-600" data-id="element-939" data-mp="25p8ides3dhvl">সব দেখুন</button>
        </div>
        <div className="space-y-2" data-id="element-940" data-mp="20pcd7c7nrkeg">
          {mobileHistory.slice(0, 4).map(h => <button key={h.id} onClick={() => nav.go('history')} className="flex w-full items-center gap-3 rounded-lg border border-border bg-white p-3 text-left" data-id="element-941" data-mp="1vrkmglir24bu">
              <div className="min-w-0 flex-1" data-id="element-942" data-mp="1m1hi5p66h3y7">
                <p className="text-sm font-semibold text-navy-900" data-id="element-943" data-mp="1m2aquvop63iz">{h.vehicle}</p>
                <p className="truncate text-[11px] text-slate-500" data-id="element-944" data-mp="1i0p8wvxb2z1x">{h.driver} • {h.time}</p>
              </div>
              <StatusBadge tone={resultTone(h.result)} data-id="element-945" data-mp="1czrt2pzrqh3l">{h.result}</StatusBadge>
            </button>)}
        </div>
      </div>
      <MobileBottomNav nav={nav} data-id="element-946" data-mp="183t696u3975a" />
    </div>;
}